import { styled } from "@vw-marketing/us-components";

export const StyledRegistrationWrapper: any = styled.div``;